import { render, staticRenderFns } from "./MapIconSunScholl.vue?vue&type=template&id=3bd62fce&scoped=true&"
import script from "./MapIconSunScholl.vue?vue&type=script&lang=js&"
export * from "./MapIconSunScholl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd62fce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd62fce')) {
      api.createRecord('3bd62fce', component.options)
    } else {
      api.reload('3bd62fce', component.options)
    }
    module.hot.accept("./MapIconSunScholl.vue?vue&type=template&id=3bd62fce&scoped=true&", function () {
      api.rerender('3bd62fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconSunScholl.vue"
export default component.exports